import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { Renders } from '@ow/ditto-core'
import Ditto from '../ditto/register.trans'

const Render = function ({
  value,
  defs,
  rowData,
  rowIndex,
  fields,
  className,
  hooks,
  renders,
}) {
  return (
    <div className={className}>
      <ErrorBoundary fallback={<>渲染错误</>}>
        <Renders
          value={value}
          defs={defs}
          rowData={rowData}
          rowIndex={rowIndex}
          fields={fields}
          hooks={hooks}
          rendersMap={renders}
          Ditto={Ditto}
        />
      </ErrorBoundary>
    </div>
  )
}

export default React.memo(Render)
